import { Star } from 'lucide-react'
import { ImageHelper } from '../helpers/image.helper'

const HEADER_CONFIG = {
  TOP_BAR: {
    LEFT: [
      {
        title: 'topbar.left.about',
        href: '/lp/coolmate-101?itm_source=navbar',
      },
      // {
      //   title: 'topbar.left.84rising',
      //   href: '/84rising?itm_source=navbar',
      // },
      {
        title: 'topbar.left.coolxprint',
        href: '/lp/coolxprint-mo-hinh-dat-san-xuat-theo-yeu-cau?itm_source=navbar',
      },
    ],
    RIGHT: [
      {
        title: 'topbar.right.coolclub',
        href: '/coolclub?itm_source=navbar',
        icon: Star,
      },
      {
        title: 'topbar.right.blog',
        href: '/blog',
        className: 'opacity-60 hover:opacity-100',
      },
      {
        title: 'topbar.right.support',
        href: '/page/trung-tam-dich-vu-khach-hang?itm_source=navbar',
        className: 'opacity-60 hover:opacity-100',
      },
      {
        title: 'topbar.right.login',
        href: '/login',
        className: 'opacity-60 hover:opacity-100',
      },
    ],
  },
}

const FOOTER_CONFIG = {
  title: 'title',
  description: 'description',
  feedback: {
    title: 'feedback.title',
    link: 'https://form.omicrm.io/55551p112pi1e517p99h17h1',
  },
  contact: {
    hotline: {
      title: 'contact.hotline.title',
      numbers: ['1900.272737', '028.7777.2737'],
      workingHours: 'contact.hotline.workingHours',
      iconUrl: '/images/footer/icon-hotline.svg',
    },
    email: {
      title: 'contact.email.title',
      address: 'contact.email.address',
      iconUrl: '/images/footer/icon-email.svg',
    },
  },
  socials: [
    {
      platform: 'socials.facebook',
      iconUrl: '/images/footer/icon-facebook.svg',
      url: 'https://www.facebook.com/coolmate.me',
    },
    {
      platform: 'socials.zalo',
      iconUrl: '/images/footer/icon-zalo.svg',
      url: 'https://zalo.me/1517736583279228381',
    },
    {
      platform: 'socials.tiktok',
      iconUrl: '/images/footer/icon-tiktok.svg',
      url: 'https://www.tiktok.com/@cool.coolmate',
    },
    {
      platform: 'socials.instagram',
      iconUrl: '/images/footer/icon-instagram.svg',
      url: 'https://www.instagram.com/coolmate.me/',
    },
    {
      platform: 'socials.youtube',
      iconUrl: '/images/footer/icon-youtube.svg',
      url: 'https://www.youtube.com/channel/UCWw8wLlodKBtEvVt1tTAsMA',
    },
  ],
  addresses: [
    {
      title: 'addresses.hn_office.title',
      address: 'addresses.hn_office.address',
    },
    {
      title: 'addresses.hn_center.title',
      address: 'addresses.hn_center.address',
    },
    {
      title: 'addresses.hcm_office.title',
      address: 'addresses.hcm_office.address',
    },
    {
      title: 'addresses.rnd_center.title',
      address: 'addresses.rnd_center.address',
    },
  ],
  companyInfo: {
    name: 'companyInfo.name',
    businessId: 'companyInfo.businessId',
    licenseInfo: 'companyInfo.licenseInfo',
    certifications: [
      {
        title: 'companyInfo.certifications.trust',
        url: 'https://tinnhiemmang.vn/danh-ba-tin-nhiem/coolmateme-1646213826',
        imageUrl: ImageHelper.getImageUrl('/uploads/March2022/handle_cert.png'),
      },
      {
        title: 'companyInfo.certifications.iso9001',
        url: 'https://www.dmca.com/Protection/Status.aspx?ID=c6fdbdee-127c-4cf1-923d-7efe75201df6&refurl=https://www.coolmate.me/',
        imageUrl: ImageHelper.getImageUrl(
          '/uploads/March2022/dmca_protected_15_120.png'
        ),
      },
      {
        title: 'companyInfo.certifications.iso14001',
        url: '#',
        imageUrl: '/images/footer/icon-iso-14001.png',
      },
      {
        title: 'companyInfo.certifications.hvnclc',
        url: 'http://online.gov.vn/(X(1)S(3e0hkhscv5zs101mhuopx43a))/Home/WebDetails/53184?AspxAutoDetectCookieSupport=1',
        imageUrl: '/images/footer/icon-hvnclc.png',
      },
    ],
  },
  menu: [
    [
      {
        title: 'menu.coolclub.title',
        items: [
          {
            label: 'menu.coolclub.account',
            url: '/account/info?itm_source=footerm',
            condition: "Cookie::get('user_info')",
          },
          {
            label: 'menu.coolclub.register',
            url: '/register?itm_source=footerm',
            condition: "!Cookie::get('user_info')",
          },
          {
            label: 'menu.coolclub.privileges',
            url: '/coolclub?itm_source=footer',
          },
        ],
      },
      {
        title: 'menu.docs.title',
        items: [
          {
            label: 'menu.docs.recruit',
            url: '/lp/coolmate-101?itm_source=footer',
          },
          {
            label: 'menu.docs.copyright',
            url: 'http://online.gov.vn/(X(1)S(sgmttobbtsiaq3l5itoicxhw))/Home/WebDetails/53184?AspxAutoDetectCookieSupport=1',
            target: '_blank',
          },
        ],
      },
    ],
    [
      {
        title: 'menu.policy.title',
        items: [
          {
            label: 'menu.policy.return',
            url: '/page/dich-vu-60-ngay-doi-tra',
          },
          {
            label: 'menu.policy.promotion',
            url: '/page/chuong-trinh-va-chinh-sach-khuyen-mai-tai-coolmate',
          },
          {
            label: 'menu.policy.privacy',
            url: '/page/chinh-sach-bao-mat-thong-tin-ca-nhan',
          },
          {
            label: 'menu.policy.shipping',
            url: '/page/dich-vu-giao-hang-coolmate',
          },
        ],
      },
      {
        title: 'menu.coolmate.title',
        items: [
          {
            label: 'menu.coolmate.changelog',
            url: '/page/changelog?itm_source=footer',
          },
        ],
      },
    ],
    [
      {
        title: 'menu.care.title',
        items: [
          {
            label: 'menu.care.experience',
            url: '/page/11-dich-vu-tai-coolmate-co-the-ban-chua-biet',
          },
          {
            label: 'menu.care.faq',
            url: '/page/faqs',
          },
        ],
      },
      {
        title: 'menu.knowledge.title',
        items: [
          {
            label: 'menu.knowledge.size',
            url: '/size-chart',
          },
          {
            label: 'menu.knowledge.blog',
            url: '/blog',
          },
        ],
      },
    ],
    [
      {
        title: 'menu.about.title',
        items: [
          {
            label: 'menu.about.rules',
            url: '/page/quy-tac-ung-xu-cua-coolmate?itm_source=footer',
          },
          {
            label: 'menu.about.coolmate101',
            url: '/lp/coolmate-101?itm_source=footer',
          },
          {
            label: 'menu.about.excellent',
            url: '/page/11-dich-vu-tai-coolmate-co-the-ban-chua-biet?itm_source=footer',
          },
          {
            label: 'menu.about.story',
            url: '/page/coolmate-story?itm_source=footer',
          },
          {
            label: 'menu.about.factory',
            url: '/page/san-pham-coolmate-duoc-san-xuat-nhu-the-nao?itm_source=footer',
          },
          {
            label: 'menu.about.care',
            url: '/collection/care-and-share?itm_source=footer',
          },
          {
            label: 'menu.about.sustainability',
            url: '/page/cam-ket-phat-trien-ben-vung?itm_source=footer',
          },
          {
            label: 'menu.about.vision',
            url: '/tam-nhin-2030',
          },
          {
            label: 'menu.about.report',
            url: '/to-giac-khieu-nai',
          },
        ],
      },
    ],
  ],
  menuMobile: [
    {
      title: 'menu.coolclub.title',
      items: [
        {
          label: 'menu.coolclub.account',
          url: '/account/info?itm_source=footerm',
          condition: "Cookie::get('user_info')",
        },
        {
          label: 'menu.coolclub.register',
          url: '/register?itm_source=footerm',
          condition: "!Cookie::get('user_info')",
        },
        {
          label: 'menu.coolclub.privileges',
          url: '/coolclub?itm_source=footer',
        },
      ],
    },
    {
      title: 'menu.policy.title',
      items: [
        {
          label: 'menu.policy.return',
          url: '/page/dich-vu-60-ngay-doi-tra',
        },
        {
          label: 'menu.policy.promotion',
          url: '/page/chuong-trinh-va-chinh-sach-khuyen-mai-tai-coolmate',
        },
        {
          label: 'menu.policy.privacy',
          url: '/page/chinh-sach-bao-mat-thong-tin-ca-nhan',
        },
        {
          label: 'menu.policy.shipping',
          url: '/page/dich-vu-giao-hang-coolmate',
        },
      ],
    },
    {
      title: 'menu.coolmate.title',
      items: [
        {
          label: 'menu.coolmate.changelog',
          url: '/page/changelog?itm_source=footer',
        },
      ],
    },
    {
      title: 'menu.care.title',
      items: [
        {
          label: 'menu.care.experience',
          url: '/page/11-dich-vu-tai-coolmate-co-the-ban-chua-biet',
        },
        {
          label: 'menu.care.faq',
          url: '/page/faqs',
        },
      ],
    },
    {
      title: 'menu.knowledge.title',
      items: [
        {
          label: 'menu.knowledge.size',
          url: '/size-chart',
        },
        {
          label: 'menu.knowledge.blog',
          url: '/blog',
        },
      ],
    },
    {
      title: 'menu.docs.title',
      items: [
        {
          label: 'menu.docs.recruit',
          url: '/lp/coolmate-101?itm_source=footer',
        },
        {
          label: 'menu.docs.copyright',
          url: 'http://online.gov.vn/(X(1)S(sgmttobbtsiaq3l5itoicxhw))/Home/WebDetails/53184?AspxAutoDetectCookieSupport=1',
          target: '_blank',
        },
      ],
    },
    {
      title: 'menu.about.title',
      items: [
        {
          label: 'menu.about.rules',
          url: '/page/quy-tac-ung-xu-cua-coolmate?itm_source=footer',
        },
        {
          label: 'menu.about.coolmate101',
          url: '/lp/coolmate-101?itm_source=footer',
        },
        {
          label: 'menu.about.excellent',
          url: '/page/11-dich-vu-tai-coolmate-co-the-ban-chua-biet?itm_source=footer',
        },
        {
          label: 'menu.about.story',
          url: '/page/coolmate-story?itm_source=footer',
        },
        {
          label: 'menu.about.factory',
          url: '/page/san-pham-coolmate-duoc-san-xuat-nhu-the-nao?itm_source=footer',
        },
        {
          label: 'menu.about.care',
          url: '/collection/care-and-share?itm_source=footer',
        },
        {
          label: 'menu.about.sustainability',
          url: '/page/cam-ket-phat-trien-ben-vung?itm_source=footer',
        },
      ],
    },
    {
      title: 'menu.contact.title',
      items: [
        {
          label: 'addresses.hn_office.full',
          url: '',
        },
        {
          label: 'addresses.hn_center.full',
          url: '',
        },
        {
          label: 'addresses.hcm_office.full',
          url: '',
        },
        {
          label: 'addresses.rnd_center.full',
          url: '',
        },
      ],
    },
  ],
}

export const LAYOUT_CONFIG = {
  HEADER: HEADER_CONFIG,
  FOOTER: FOOTER_CONFIG,
}
